import DocumentService from '@/Modules/Document/DocumentService.js'
import axios from 'axios'

export default class StatementDocumentService extends DocumentService {
  static resource = 'statements'

  static json = (statementId) =>
    axios.get(`/${this.resource}/${statementId}/json`)

  static generate = (statementId, payload) =>
    axios.post(`/${this.resource}/${statementId}/generate`, payload)
}
